import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'so-gantt-viewer-dialog',
  templateUrl: 'so-gantt-viewer-dialog.html'
})
export class SOGanttViewerDialog {

  constructor(
    public dialogRef: MatDialogRef<SOGanttViewerDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  callSomethingOnParent(_evnt){
    alert("event emitted");
}

}
